/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

const useUnMount = (effect: () => void) => useEffect(() => effect, []);

export default useUnMount;
